import HotelClassificationBusinessListResourceModel from '../../generated/types/model/resource/HotelClassificationBusinessListResourceModel';

export default class HotelClassificationBusinessListResourceViewModel extends HotelClassificationBusinessListResourceModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
